<script setup>
import Footer from '@/components/Footer.vue';
import BlockJMC from '@/components/BlockJMC.vue';
import { onMounted } from 'vue';

onMounted(async () => {
  document.title = "Thanks from Edoki Montessori Preschool";
});
</script>

<template>
  <div class="app-layout jungle-layout">
    <BlockJMC />
    <Footer :logo-path="'Edoki_logo.svg'" />
  </div>
</template>
